<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box"></div>
      <div class="search_box">
        <el-select
          placeholder="请选择活动区域"
          v-model="selectdData"
          size="mini"
          clearable
        >
          <el-option
            v-for="(value, key) in dataList"
            :key="key"
            :label="value.name"
            :value="key"
          ></el-option>
        </el-select>
        <el-button type="primary"
          size="mini"
          icon="el-icon-search" @click="selectPicture"
          plain
          >搜索</el-button
        >
      </div>
    </div>
    <div class="inside_pages_right_content chart_details_box">
      <div class="inside_pages_right_content_center chart_details_center">
        <!-- {{dataList[selectdData].url}} -->
        <div class="grade_chart_box ">
          <!-- <img v-if="thisShowPictureInfo.url"  :src="thisShowPictureInfo.url" alt="..." class="img-thumbnail grade_chart_box_img"> -->

          <AIMarker
            v-if="thisShowPictureInfo.url"
            ref="imageLabelCarrier"
            v-bind:readOnly="readOnly"
            @vmarker:onAnnoAdded="onAnnoAddeds"
            @vmarker:onDrawOne="onDrawOne"
            @vmarker:onSelect="selectOne"
            @vmarker:onAnnoRemoved="deleteLabel"
            @vmarker:onImageLoad="addMarker"
            class="edit_grade_chart_box"
            :ratio="16 / 9"
            v-bind:imgUrl="thisShowPictureInfo.url"
          >
          </AIMarker>
          <!-- @vmarker:onUpdated="getAllLabel"  -->
          <!-- @vmarker:onImageLoad="addMarker"  -->
          <!-- @vmarker:onUpdated="setTable" -->

          <div class="a" v-if="thisShowPictureInfo.url == ''">暂无隐患详情</div>
        </div>
      </div>

      <el-dialog
        title="选择风险位置"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <form class="form-horizontal form_box">
          <div class="form-group">
            <label class="col-sm-2 control-label">风险位置</label>
            <div class="col-sm-10">
              <select
                class="form-control"
                v-model="thisPicturePosition.riskAreaId"
              >
                <option value="0">请选择风险位置</option>
                <option
                  v-for="(value, key) in riskRegionList"
                  :key="key"
                  :value="value.id"
                  >{{ value.areaName }}</option
                >
              </select>
            </div>
          </div>
        </form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelAdding()">取 消</el-button>
          <el-button type="primary" @click="gradeChartLabelOperation"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- <el-dialog title="我是标题" :visible.sync="pictureTagging" :with-header="false" :append-to-body="true" size="50%">
            <AIMarker 
                    v-if="thisShowPictureInfo.url"
                    ref="aiPanel-editor" 
                    :setConfigOptions="allPostion"
                    v-bind:readOnly="readOnly"  
                    @vmarker:onDrawOne="onDrawOne" 
                    @vmarker:onUpdated="onAnnoAdded" 
                    @vmarker:onSelect="selectOne"  
                    @vmarker:onImageLoad="onImageLoads" 
                    @vmarker:onAnnoRemoved="deleteLabel" 
                    class="ai-observer  grade_chart_box_img"  
                    v-bind:uniqueKey="uuid" :ratio="16/9"  
                    v-bind:imgUrl="thisShowPictureInfo.url"
                >
            </AIMarker>
        </el-dialog> -->

      <!-- <remote-js src="/js/jquery.imageLabel.min.js" name="123"></remote-js> -->
      <!-- <div class="chart_details_tips_box">
            123123123
        </div> -->
    </div>
  </div>
</template>
<script>
import RiskGradeChart from "@/components/RiskGradeChart";
import { AIMarker } from "vue-picture-bd-marker";
export default {
  name: "",
  components: {
    AIMarker,
    RiskGradeChart
  },
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      pictureTagging: false,
      dataList: [],
      requestData: {
        schoolId: this.$store.state.schoolId
      },
      uuid: "0da9130",
      // currentImage:"url或base64",
      selectdData: 0,
      thisShowPictureInfo: {
        url: ""
      },
      readOnly: false, //是否只读
      thisSelectData: "",

      // 当前操作的位置label
      thisPicturePosition: {
        imgAreaId: 0,
        levelImgId: 0,
        riskAreaId: 0,
        coordinate: "",
        label: 0
      },
      riskRegionList: [],
      allPostion: [],
      isAddMarker: false,

      // 选中的标签位置
      selectedTabelPosition: "",

      // 风险统计
      riskStatistics: [],

      //当前选中的数据
      thisSelecedLabel: ""
    };
  },
  watch: {
    allPostion() {
      this.$nextTick(() => {
        if (this.isAddMarker == true) {
          this.addMarker();
        }
      });
    },
    riskStatistics() {
      var selectDiv = document.querySelector(
        '[data-uuid="' + this.thisSelecedLabel.uuid + '"]'
      );
      var newNodeCenter = document.createElement("div");
      newNodeCenter.className = "chart_details_tips_box alert alert-success";
      var innerHTMLtext = '<div>风险统计<a href="">查看详情</a></div>';
      innerHTMLtext += "<div><ul>";
      var riskStatistics = this.riskStatistics;
      for (var riskStatisticsKey in riskStatistics) {
        innerHTMLtext +=
          "<li>" +
          this.$store.state.select.riskLevel[
            riskStatistics[riskStatisticsKey].riskLevel
          ].levelNameOne +
          "：" +
          riskStatistics[riskStatisticsKey].num +
          "</li>";
      }
      innerHTMLtext += "</ul></div>";

      newNodeCenter.innerHTML = innerHTMLtext;
      selectDiv.appendChild(newNodeCenter);
    }
  },
  computed: {},
  methods: {
    cancelAdding() {
      this.$nextTick(() => {
        if (this.isAddMarker == true) {
          this.addMarker();
        }
      });

      this.dialogFormVisible = false;
    },

    // 删除标记
    deleteLabel(data1) {
      this.delGradeChartLabel(data1.labelId);
    },
    // 添加标记
    addMarker() {
      this.$refs["imageLabelCarrier"].getMarker().clearData();
      this.$refs["imageLabelCarrier"].getMarker().renderData(this.allPostion);
      this.isAddMarker = true;
    },
    openEditPicture() {
      this.pictureTagging = true;
      this.readOnly = false;
    },
    onAnnoAddeds(data) {
      // console.log(data)
    },

    // 新增位置
    onDrawOne(data) {
      this.thisPicturePosition.label = data.tag;
      this.thisPicturePosition.coordinate = data.position;
      // console.log(data)
      // this.getRiskRegion()
      this.thisSelectData = data;
      if (!data.labelId) {
        this.dialogFormVisible = true;
      }
    },
    // 获取选择的位置标签
    selectOne(data) {
      this.thisSelecedLabel = data;
      this.getGradeChartRiskStatistics(data.tagName);
      if (this.selectedTabelPosition) {
        var prevDiv = document.querySelector(
          '[data-uuid="' + this.selectedTabelPosition.uuid + '"]'
        );

        var removeObj = document.querySelector(".chart_details_tips_box");
        if (removeObj) {
          var parentObj = removeObj.parentNode;
          parentObj.removeChild(removeObj);
        }
      }

      this.selectedTabelPosition = data;
      this.thisPicturePosition.imgAreaId = data.labelId;
      this.thisPicturePosition.coordinate = data.position;
      this.thisPicturePosition.riskAreaId = data.riskAreaId;
      this.thisPicturePosition.label = data.tag;
      var allPostion = this.allPostion;
      for (var markerKey in allPostion) {
        if (allPostion[markerKey].labelId == data.labelId) {
          this.allPostion[markerKey] = data;
        }
      }
      this.gradeChartLabelOperation();
      // this.thisPicturePosition.coordinate = data.position

      // console.log(data)
    },

    // 选择风险四色图
    selectPicture() {
      // console.log(this.selectdData)
      if (this.selectdData.toString() == '') {
          this.thisShowPictureInfo.url = ''
          return
      }
      this.thisShowPictureInfo.url =
        this.$store.state.config.fileUrl + this.dataList[this.selectdData].url;
      this.thisPicturePosition.levelImgId = this.dataList[this.selectdData].id;
      this.allPostion = [];
      this.dataList[this.selectdData].riskLevelImgAreas.forEach((element) => {
        var markerInfo = {
          tag: element.label,
          position: JSON.parse(element.coordinate),
          tagName: element.riskArea.areaName,
          className: this.$store.state.select.riskLevel[element.riskArea.level]
            .classNameTwo,
          labelId: element.imgAreaId,
          riskAreaId: element.riskAreaId
        };
        this.allPostion.push(markerInfo);
      });
      // this.riskLevelFourColorsPicture()

      // this.thisRef.renderData(this.allPostion)
      // this.$refs['imageLabelCarrier'].getMarker().renderData(this.allPostion)
      // this.thisRef.getMarker().renderData(this.allPostion)
      // this.$refs['imageLabelCarrier'].renderData(this.allPostion)
      // this.addMarker()
      // console.log(this.thisShowPictureInfo.url)
    },

    // 获取四色图的风险统计
    async getGradeChartRiskStatistics(areaName) {
      let newRequestData = {
        schoolId: this.$store.state.schoolId,
        areaName: areaName
      };
      let res = await this.$Http.getGradeChartRiskStatistics(newRequestData);
      if (res.code == 200) {
        this.riskStatistics = res.data;
        // console.log(this.riskStatistics)
        // this.selectPicture()
        // this.addMarker()
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取风险等级四色图
    async riskLevelFourColorsPicture() {
      let newRequestData = this.requestData;
      let res = await this.$Http.riskFourColorsPictureListTwo(
        newRequestData,
        true
      );
      if (res.code == 200) {
        this.dataList = res.data;
        // console.log(this.dataList)
        this.selectPicture();
        // this.addMarker()
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 删除四色图标签
    async delGradeChartLabel(id = "") {
      if (id == "") {
        return false;
      }
      let newRequestData = {
        imgAreaId: id
      };
      let res = await this.$Http.delGradeChartLabel(newRequestData);
      if (res.code == 200) {
        this.thisPicturePosition.imgAreaId = 0;
        var allPostion = this.allPostion;
        for (var markerKey in allPostion) {
          if (allPostion[markerKey].labelId == id) {
            this.allPostion.splice(markerKey, 1);
          }
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 四色图标签操作 新增/编辑
    async gradeChartLabelOperation() {
      var thisLabelData = this.thisPicturePosition;
      let newRequestData = {
        imgAreaId: thisLabelData.imgAreaId, // 各个位置风险等级id（编辑时传）
        levelImgId: thisLabelData.levelImgId, // 风险等级四色图id
        riskAreaId: thisLabelData.riskAreaId, // 风险区域id
        coordinate: JSON.stringify(thisLabelData.coordinate), // 坐标
        label: thisLabelData.label // 方块区域标记
      };
      // if(!newRequestData.imgAreaId){
      //     return false
      // }
      // this.dialogFormVisible = false
      if (
        newRequestData.imgAreaId == 0 ||
        newRequestData.imgAreaId == undefined
      ) {
        delete newRequestData.imgAreaId;
      }
      let res = await this.$Http.gradeChartLabelOperation(newRequestData, true);
      if (res.code == 200) {
        // console.log(this.thisPicturePosition.imgAreaId)
        if (this.thisPicturePosition.imgAreaId == 0) {
          var markerInfo = {
            tag: res.data.label,
            position: JSON.parse(res.data.coordinate),
            tagName: res.data.riskArea.areaName,
            className: this.$store.state.select.riskLevel[
              res.data.riskArea.level
            ].classNameTwo,
            labelId: res.data.imgAreaId,
            riskAreaId: res.data.riskAreaId
          };
          this.allPostion.push(markerInfo);

          var listData = {
            coordinate: res.data.coordinate,
            imgAreaId: res.data.imgAreaId,
            label: res.data.label,
            riskArea: {
              areaName: res.data.riskArea.areaName,
              level: res.data.riskArea.level
            },
            riskAreaId: res.data.riskAreaId
          };
          // console.log(listData)

          this.dataList[this.selectdData].riskLevelImgAreas.push(listData);
          // console.log(this.dataList)
        }
        this.thisPicturePosition.imgAreaId = 0;
        // console.log(res.data)
        this.dialogFormVisible = false;
        // this.riskLevelFourColorsPicture()
        // this.$message({
        //     type: 'success',
        //     message: res.messsage
        // });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取风险区域
    async getRiskRegion() {
      let newRequestData = this.requestData;
      let res = await this.$Http.getRiskRegion(newRequestData);
      if (res.code == 200) {
        this.riskRegionList = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.riskLevelFourColorsPicture();
    this.getRiskRegion();
  }
};
</script>

<style scoped>
@import "/css/jquery.imageLabel.min.css";
.a{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
